<ion-header>
  <cc-header [info]="header" (iconClicked)="modalController.dismiss()">
  </cc-header>
</ion-header>

<ion-content>
  <img [src]="imageUrl">
</ion-content>